import { Form, Col } from 'react-bootstrap'
import { connect } from 'formik'
import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { getLocaleFormLabelKey } from '../../utils/helpers'

const propTypes = {
  fieldConfig: PropTypes.object.isRequired
}

function AddressLine2Control({ formik, fieldConfig, canEdit, alignCenter = true, columnSize = 5 }) {
  const { t } = useTranslation('common')
  let localizedFormLabel = ''
  if (fieldConfig?.label) {
    localizedFormLabel = t(getLocaleFormLabelKey(fieldConfig.label))
  }
  return (
    <Form.Group
      as={Col}
      md={columnSize}
      controlId="formAddress2"
      className={alignCenter ? 'mx-auto' : ''}
    >
      <Form.Label>
        {localizedFormLabel}
        {/* Address 2 is special case where we sometimes hide the label. If empty label, don't show optional. */}
        {!fieldConfig?.required && fieldConfig?.label.length ? (
          <span className="form-optional">({t('Optional')})</span>
        ) : null}
      </Form.Label>
      <Form.Control
        type="text"
        name="street2"
        value={formik.values.street2}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        placeholder="Apartment, suite, unit, building, floor, etc"
        isInvalid={formik.touched.street2 && !!formik.errors.street2}
        maxLength={255}
        readOnly={!canEdit}
        required={fieldConfig?.required}
      />
      <Form.Control.Feedback type="invalid">{formik.errors.street2}</Form.Control.Feedback>
    </Form.Group>
  )
}

AddressLine2Control.propTypes = propTypes

export default connect(AddressLine2Control)
